
export const OfficeMap = () => {
  return (
    <div className="mt-10">
      <h2 className="text-2xl font-bold mb-6 text-center">Visit Our Office</h2>
      <div className="w-full h-80 bg-slate-200 rounded-lg overflow-hidden">
        {/* In a real app, this would be your Google Maps or other map embed */}
        <div className="w-full h-full flex items-center justify-center">
          <p className="text-muted-foreground">
            Map placeholder - In a real application, this would be an embedded map showing our Bangalore office location
          </p>
        </div>
      </div>
    </div>
  );
};
